export default "__VITE_ASSET__Dv7EN4qb__"